import * as React from 'react';
import { cn } from '../../lib/utils';

/** Superfície dos cards: fundo, borda, raio e shadow-sm. */
function Box({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="box"
      className={cn(
        'box min-w-0 rounded-lg border border-border bg-card text-card-foreground shadow-md',
        className,
      )}
      {...props}
    />
  );
}

export { Box };
